import {
  Dashboard,
  Employee,
  Customer,
  Report,
  Services,
  Organization,
  Booking,
  ServiceType,
  IncomeType,
  ExpenseType,
  Budget,
  Expense,
  FullCalendarPage,
  Device,
  Stats,
  CeItem,
  PreBooking,
  PETBooking,
  Inpatient,
  RoomBed,
  Room,
  Ward,
  Document,
  SurgeryPlan,
  InpatientDashboard,
  SurgeryType,
  ShiftSchedule,
  Caller,
  Feedback,
  ShiftConfig,
  CallerReport,
  ShiftCheck,
  ShiftCalendar,
  ShiftHoliday,
  WoundDashboard,
} from "modules/admin";
import WoundSymptonMaster from "modules/admin/wound_master";
import WoundMaterial from "modules/admin/wound_material";
import WoundMonitoring from "modules/admin/wound_monitoring";

export default [
  {
    name: "Хянах самбар",
    path: "/",
    element: <Dashboard />,
    role: ["Админ", "CEO", "Гишүүн"],
  },
  {
    name: "Дуудлага",
    path: "/callreport",
    element: <CallerReport />,
    role: ["Админ", "CEO"],
  },
  {
    name: "Хэвтэн самбар",
    path: "/inpatient-dashboard",
    element: <InpatientDashboard />,
    role: ["Админ", "CEO"],
  },
  {
    name: "Цаг захиалга",
    path: "/prebooking",
    element: <PreBooking />,
    role: [
      "Ресейпшн",
      "Эмч",
      "Техникч",
      "Нягтлан",
      "Админ",
      "CEO",
      "Эрхлэгч",
      "Менежер",
      "Physician",
      "Нягтлан",
    ],
  },

  {
    name: "Шинжилгээ",
    path: "/booking",
    element: <Booking />,
    role: [
      "Ресейпшн",
      "Эмч",
      "Техникч",
      "Админ",
      "CEO",
      "Гишүүн",
      "Эрхлэгч",
      "Менежер",
      "Нягтлан",
    ],
  },
  {
    name: "PET Шинжилгээ",
    path: "/pet-booking",
    element: <PETBooking />,
    role: [
      "Ресейпшн",
      "Эмч",
      "Нягтлан",
      "Техникч",
      "Админ",
      "CEO",
      "Эрхлэгч",
      "Менежер",
      "Physician",
    ],
  },
  {
    name: "Үзүүлэлт",
    path: "/stats",
    element: <Stats />,
    role: [
      "Ресейпшн",
      "Эмч",
      "Техникч",
      "Админ",
      "CEO",
      "Гишүүн",
      "Эрхлэгч",
      "Менежер",
      "Physician",
      "Нягтлан",
    ],
  },
  {
    name: "Мэс засал",
    path: "/surgery",
    element: <SurgeryPlan />,
    role: ["Админ", "CEO", "Менежер", "Хэвтэн", "Ресейпшн", "Нягтлан"],
  },
  {
    name: "Мэс заслын нэр",
    path: "/surgery-type",
    element: <SurgeryType />,
    role: ["Админ", "CEO", "Менежер", "Хэвтэн", "Нягтлан"],
  },
  // {
  //   name: "Feedback",
  //   path: "/feedback",
  //   element: <Feedback />,
  //   role: [
  //     "Ресейпшн",
  //     "Эмч",
  //     "Нягтлан",
  //     "Техникч",
  //     "Админ",
  //     "Эрхлэгч",
  //     "Менежер",
  //     "Physician",
  //   ],
  // },
  // {
  //   name: "Ажлын хуваарь",
  //   path: "/schedule",
  //   element: <ShiftSchedule />,
  //   role: ["CEO", "Админ", "Менежер", "Нягтлан"],
  // },
  // {
  //   name: "Ажлын хуваарь",
  //   path: "/shift/calendar",
  //   element: <ShiftCalendar />,
  //   role: ["CEO", "Админ", "Менежер", "Нягтлан", "Техникч", "Ресейпшн"],
  // },
  // {
  //   name: "Хуваарь тохиргоо",
  //   path: "/shift-config",
  //   element: <ShiftConfig />,
  //   role: ["Эмч", "Нягтлан", "Админ", "CEO", "Эрхлэгч", "Менежер"],
  // },
  // {
  //   name: "Хуваарь тохиргоо",
  //   path: "/shift-holiday",
  //   element: <ShiftHoliday/>,
  //   role: ["Эмч", "Нягтлан", "Админ", "CEO", "Эрхлэгч", "Менежер"],
  // },
  // {
  //   name: "Хуваарь тохиргоо",
  //   path: "/shift-check",
  //   element: <ShiftCheck />,
  //   role: ["Нягтлан", "Админ", "CEO", "Менежер"],
  // },
  {
    name: "Тайлан",
    path: "/report",
    element: <Report />,
    role: ["CEO", "Админ", "Менежер", "Нягтлан", "Эмч", "Эрхлэгч"],
  },
  {
    name: "Орлого зарлага",
    path: "/incomeandexpense",
    element: <Budget />,
    role: ["Админ", "CEO", "Менежер"],
  },
  // Хүний нөөц
  {
    name: "Ажилчид",
    path: "/employee",
    role: ["Админ", "CEO", "Менежер"],
    element: <Employee />,
  },
  {
    name: "Харилцагч",
    path: "/customer",
    role: ["Ресейпшн", "Админ", "CEO", "Менежер", "Техникч"],
    element: <Customer />,
  },
  // {
  //   name: "Хуваарь",
  //   path: "/calendar",
  //   role: ["Ресейпшн", "Админ", "CEO", "Эмч", "Менежер", "Нягтлан"],
  //   element: <FullCalendarPage />,
  // },
  //Хэвтэн эмчлүүлэх
  {
    name: "Хэвтэн эмчлүүлэх",
    path: "/inpatient",
    role: [
      "Эмч",
      "Техникч",
      "Админ",
      "CEO",
      "Гишүүн",
      "Эрхлэгч",
      "Менежер",
      "Нягтлан",
      "Хэвтэн",
    ],
    element: <Inpatient />,
  },
  {
    name: "Тасаг",
    path: "/ward",
    role: [
      "Эмч",
      "Техникч",
      "Админ",
      "CEO",
      "Гишүүн",
      "Эрхлэгч",
      "Нягтлан",
      "Хэвтэн",
    ],
    element: <Ward />,
  },
  {
    name: "Өрөө",
    path: "/room",
    role: [
      "Эмч",
      "Техникч",
      "Админ",
      "CEO",
      "Гишүүн",
      "Эрхлэгч",
      "Нягтлан",
      "Хэвтэн",
    ],
    element: <Room />,
  },
  {
    name: "ор ",
    path: "/room-bed",
    role: [
      "Эмч",
      "Техникч",
      "Админ",
      "CEO",
      "Гишүүн",
      "Эрхлэгч",
      "Нягтлан",
      "Хэвтэн",
    ],
    element: <RoomBed />,
  },
  {
    name: "бичиг баримт ",
    path: "/document",
    role: [
      "Эмч",
      "Техникч",
      "Админ",
      "CEO",
      "Гишүүн",
      "Эрхлэгч",
      "Нягтлан",
      "Хэвтэн",
    ],
    element: <Document />,
  },
  {
    name: "Хуваарь",
    path: "/calendar",
    role: ["Ресейпшн", "Админ", "CEO", "Эмч", "Менежер", "Нягтлан"],
    element: <FullCalendarPage />,
  },
  // Тохиргоо
  {
    name: "Үйлчилгээ",
    path: "/services",
    role: ["Админ", "CEO", "Менежер"],
    element: <Services />,
  },
  {
    name: "Аппарат",
    path: "/devices",
    role: ["Админ", "CEO", "Менежер"],
    element: <Device />,
  },
  {
    name: "Бодис",
    path: "/ceitem",
    role: ["Админ", "CEO", "Менежер"],
    element: <CeItem />,
  },
  {
    path: "/caller",
    element: <Caller></Caller>,
    role: ["Админ", "CEO", "Менежер"],
  },
  {
    name: "Үйлчилгээний төрөл",
    path: "/servicetype",
    role: ["Админ", "CEO", "Менежер"],
    element: <ServiceType />,
  },
  {
    name: "Компаний мэдээлэл",
    path: "/organization",
    role: ["Админ", "CEO", "Менежер"],
    element: <Organization />,
  },
  {
    name: "Шинж тэмдэгийн тохиргоо",
    path: "/wound-master",
    role: ["Админ", "CEO", "Менежер", "Сувилагч", "Хэвтэн"],
    element: <WoundSymptonMaster />,
  },
  {
    name: "Боолт Хяналты",
    path: "/wound-monitoring",
    role: ["Админ", "CEO", "Менежер", "Сувилагч", "Хэвтэн"],
    element: <WoundMonitoring />,
  },
  {
    name: "Dashboard",
    path: "/wound-dashboard",
    role: ["Админ", "CEO", "Менежер", "Хэвтэн", "Сувилагч"],
    element: <WoundDashboard />,
  },
  {
    name: "WoundMaterial",
    path: "/wound-material",
    role: ["Админ", "CEO", "Менежер", "Хэвтэн", "Сувилагч"],
    element: <WoundMaterial />,
  },
  // {
  //   name: "Дэд Зарлага",
  //   path: "/expense",
  //   role: ["Админ", "CEO", "Менежер"],
  //   element: <Expense />,
  // },
];
